<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return  {
      refreshData: null
    }
  },
  mounted() {
    // this.countTime();
    if (this._isMobile()) {
      this.$router.replace('/m');
    } else {
      this.$router.replace('/');
    }
  },
  methods: {
    // countTime() {
    //   this.refreshData = setInterval(() => {
    //     this.$router.go(0)
    //   },1000*60*60*12);
    //
    // },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  // beforeDestroy(){
  //   clearInterval(this.refreshData);
  //   this.refreshData=null;
  // }
}
</script>

<style lang="less">
html, body {
  height: 100%;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

P {
  margin: 0;
  padding: 0;
}
</style>
